import React, { createContext, useState, useContext } from "react";
import ReactGA from "react-ga4";

const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
    const [initialized, setInitialized] = useState(false);

    const initializeAnalytics = () => {
        if (!initialized) {
            ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
            setInitialized(true);
        }
    };

    return (
        <AnalyticsContext.Provider value={{ initialized, initializeAnalytics }}>
            {children}
        </AnalyticsContext.Provider>
    );
};

export const useAnalytics = () => useContext(AnalyticsContext);
